import { useWindowResize } from '@utils/domUtils'

import { CurrencyType } from '@model/WalletDto'

import { useFixTradingWebSocketContext } from '../context/FixTradingWebSocketContext'
import type { DxtradeInstrumentMap } from '../hooks/useDxtradeInstruments'
import type { PendingOrderWithLots } from '../hooks/usePendingOrdersWithLots'
import { CardPendingView } from './CardPendingView'
import { PendingOrdersTable } from './PendingOrdersTable'

type Props = {
  accountCurrency?: CurrencyType
  accountCode?: string
  orders: PendingOrderWithLots[]
  isLoading: boolean
  dxtradeInstruments?: DxtradeInstrumentMap
  hasActiveFilters?: boolean
}

export function PendingTab({
  orders,
  accountCurrency,
  accountCode,
  isLoading,
  dxtradeInstruments,
  hasActiveFilters,
}: Props) {
  const isMobile = useWindowResize()
  const { cancelOrder, newOrder, changePendingOrderSlTp, replaceOrder } =
    useFixTradingWebSocketContext()

  return isMobile ? (
    <CardPendingView
      orders={orders}
      isLoading={isLoading}
      accountCode={accountCode}
      dxtradeInstruments={dxtradeInstruments}
      hasActiveFilters={hasActiveFilters}
    />
  ) : (
    <PendingOrdersTable
      orders={orders}
      isLoading={isLoading}
      cancelOrder={cancelOrder}
      newOrder={newOrder}
      changePendingOrderSlTp={changePendingOrderSlTp}
      replaceOrder={replaceOrder}
      accountCurrency={accountCurrency}
      accountCode={accountCode}
      dxtradeInstruments={dxtradeInstruments}
      hasActiveFilters={hasActiveFilters}
    />
  )
}

export default PendingTab
